import axios from "axios";

export default async function getRecycleDocument(projectName, formName, documentId) {
    // const res = await axios.get(`project/${projectName}/${formName}/Document/${documentId}/image`, { responseType: "blob" })
    const res = await axios.get(`/project/${projectName}/${formName}/document/${documentId}/recycle`, { responseType: "blob" })
    return res;
}